import { render, staticRenderFns } from "./NFTSingleComponent.vue?vue&type=template&id=61282b30&scoped=true&"
import script from "./NFTSingleComponent.vue?vue&type=script&lang=ts&"
export * from "./NFTSingleComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NFTSingleComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NFTSingleComponent.vue?vue&type=style&index=1&id=61282b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61282b30",
  null
  
)

export default component.exports